import { type JSX } from 'react';

import type { DropdownSection, RichNavItem } from '../types';
import LayeredMenuItem from './LayeredMenuItem';

interface LayeredMenuProps {
    sections: DropdownSection[];
}

function isSectionRich(items: RichNavItem[]): boolean {
    return items.some((item) => item.icon || item.stockblocksIcon || item.description);
}

export default function LayeredMenu({ sections }: LayeredMenuProps): JSX.Element {
    return (
        <div className="flex flex-col p-8 gap-4">
            {sections.map((section) => {
                const isRich = isSectionRich(section.items);
                return (
                    <div key={section.title}>
                        {/* Section header + divider */}
                        <div className="flex flex-col gap-2 pt-4 first:pt-0">
                            <span className="pb-2 text-sm text-gray-900">{section.title}</span>
                            <div className="h-px bg-gray-200" />
                        </div>

                        {/* Section items — gap-4 for plain links, gap-6 for rich items */}
                        <div className={`flex flex-col ${isRich ? 'gap-6' : 'gap-4'} pt-4`}>
                            {section.items.map((item) => (
                                <LayeredMenuItem key={item.href} item={item} />
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
